import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import bankAccount from './modules/bankAccount'
import goldInventories from './modules/goldInventories'
import goldBalanceNew from './modules/goldBalance'
import glossaries from './modules/glossaries'
import events from './modules/events'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bankAccount,
    goldInventories,
    goldBalanceNew,
    glossaries,
    events
  },

  state,
  actions,
  mutations,
  getters
})
